import Grid from '@mui/material/Grid';

import { CreateFields } from 'reservations/form/components/CreateFields';
import MarketingFinePrint from 'reservations/form/components/MarketingFinePrint';
import { ModifyFields } from 'reservations/form/components/ModifyFields';
import { WaitlistFields } from 'reservations/form/components/WaitlistFields';
import { useBookingTypes } from 'reservations/form/hooks/useBookingTypes';

export const BookingFormModal = () => {
  const { isModify, isWaitlist } = useBookingTypes();

  const DinerFields = () => {
    switch (true) {
      case isModify:
        return <ModifyFields />;
      case isWaitlist:
        return <WaitlistFields />;
      default:
        return <CreateFields />;
    }
  };

  return (
    <Grid
      container
      gap="32px"
      direction="column"
      sx={{ px: '32px', py: '64px', pt: '24px' }}
    >
      <DinerFields />
      {!isModify && (
        <Grid item>
          <MarketingFinePrint />
        </Grid>
      )}
    </Grid>
  );
};
